import React from 'react';

interface IMainWrapper {
    children: any;
    bgGray?: true;
}

export default function ({bgGray, children}: IMainWrapper) {
    if (bgGray) {
        return (
            <main style={{minHeight: `calc(100vh - 245px)`, background: '#e6e6e6'}}>
                <div style={{background: 'white'}}>{children}</div>
            </main>
        );
    } else {
        return <main style={{minHeight: `calc(100vh - 245px)`}}>{children}</main>;
    }
}
